import { Box, CircularProgress, Tooltip, Typography } from "@mui/material";
import { ParagraphText, UBButton, UBInput } from "../../../../Libraries";
import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./AddQuickItem.module.css";
import UBDateSelect from "../../../../Libraries/UBDateSelect";
import {
  ActionPlusIcon,
  DropDown,
  GreyBarcode,
  PlusIconUnFill,
  StockAddIcon,
} from "../../../../assets/icons/icon";
import { unitKB_2 } from "../../../../constants";
import { LanguageContext } from "../../../../context/LanguageContext";
import useDebouncedValue from "../../../../hooks/useDebouncedValue";
import { handleApi } from "../../../../apis";
import defaultImage from "../../../../assets/images/no-photos.png";
import {
  GET_PRODUCTS,
  GET_PRODUCTS_BY_BARCODE,
} from "../../../../apis/configuration";
import { useSnackbar } from "../../../../context/SnackbarContext";
import {
  blurAllInputField,
  removeLeadingZeros,
  removeRsFromValue,
  validatePriceQtyInput,
  ValidateUploadedFile,
  validString,
} from "../../../../utils";
import BarcodeReader from "react-barcode-reader";
import { useAuthContext } from "../../../../context/AuthContext";
import withObservables from "@nozbe/with-observables";
import UnitModal from "../../../common/Modals/UnitModal";
import { formatNum } from "../../../../oscar-pos-core/constants";

import { analytics, triggerLogEvent } from "../../../../config/firebase";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AddQuickItem = ({
  data,
  visibleColumns,
  setData,
  handleSave,
  customUnit,
  gridTemplateColumns,
}) => {
  const { showSnackbar } = useSnackbar();
  const { business } = useAuthContext();
  const [makeQuickItem, setMakeQuickItem] = useState(false);
  const [showUnitModal, setShowUnitModal] = useState(false);
  const [I18n] = useContext(LanguageContext);
  const [dateSelectRefs, setDateSelectRefs] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [SearchName, setSearchName] = useState("");
  const [productList, setproductList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [isLoss, setIsLoss] = useState(false);

  const debounceSearchName = useDebouncedValue(SearchName, 500);
  const nameRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(-1);
  let cancelToken = useRef();

  const [quickItemStates, setQuickItemStates] = useState({
    name: "",
    stock: "",
    image_url: "",
    unit_conversion: "",
    cost_price: "",
    selling_price: "",
    barcode: "",
    unit: "",
    secondary_unit: "",
    batch_number: "",
    wholesale_price: "",
    expiry_date: "",
    manufacturing_date: "",
    low_stock: "",
  });

  const [modalUnitState, setModalUnitState] = useState({
    unit: "",
    secondary_unit: "",
    unit_conversion: "",
  });
  const navigate = useNavigate();
  const enableSave = Boolean(quickItemStates.name);

  const sellInputRef = useRef();
  const costInputRef = useRef();
  const itemRefs = useRef([]);

  useEffect(() => {
    const list = customUnit.length
      ? customUnit.map((item) => {
        return {
          label: item.name,
          value: item.name,
        };
      })
      : [];
    setUnitList([...unitKB_2, ...list]);
  }, [customUnit.length]);

  useEffect(() => {
    if (debounceSearchName) {
      cancelPreviousCall();
      getProductSuggestion(debounceSearchName);
    } else {
      setproductList([]);
    }
  }, [debounceSearchName]);
  useEffect(() => {
    if (activeIndex >= 0 && itemRefs.current[activeIndex]) {
      itemRefs.current[activeIndex].scrollIntoView({
        block: "nearest",
        behavior: "auto",
      });
    }
  }, [activeIndex]);
  useEffect(() => {
    itemRefs.current = [];
  }, [productList]);

  const cancelPreviousCall = () => {
    if (cancelToken.current)
      cancelToken.current.cancel(
        "New request appears, canceling previous request.",
      );
    cancelToken.current = axios.CancelToken.source();
  };

  const getProductByBarCode = (product_code) => {
    handleApi(GET_PRODUCTS_BY_BARCODE, { product_code }, null, navigate)
      .then((res) => {
        handleSetProductName(res.data);
      })
      .catch((err) => {
      });
  };
  const getProductSuggestion = (product_name) => {
    setIsLoading(true);
    handleApi(GET_PRODUCTS, { product_name }, cancelToken.current, navigate)
      .then((res) => {
        setIsLoading(false);
        setproductList(res.products);
      })
      .catch((err) => {
        if (err.message === "New request appears, canceling previous request.")
          return;
        setIsLoading(false);
      });
  };

  const addQuickItem = () => {
    triggerLogEvent(analytics, "sb_quick_item_created");
    setSearchName("");
    handleSave(quickItemStates);
    setMakeQuickItem(false);
    setQuickItemStates({
      name: "",
      stock: "",
      image_url: "",
      unit_conversion: "",
      cost_price: "",
      selling_price: "",
      barcode: "",
      unit: "",
      secondary_unit: "",
      batch_number: "",
      wholesale_price: "",
      expiry_date: "",
      manufacturing_date: "",
      low_stock: "",
    });
  };
  const enableQuickItem = () => {
    triggerLogEvent(analytics, "sb_quick_item");
    setTimeout(() => setMakeQuickItem(true), 100);
  };

  const cancelQuickItem = () => {
    setMakeQuickItem(false);
    setQuickItemStates({
      name: "",
      stock: "",
      image_url: "",
      unit_conversion: "",
      cost_price: "",
      selling_price: "",
      barcode: "",
      unit: "",
      secondary_unit: "",
      batch_number: "",
      wholesale_price: "",
      expiry_date: "",
      manufacturing_date: "",
      low_stock: "",
    });
  };

  const handleImageChange = () => {
    triggerLogEvent(analytics, "sb_item_photo_start");
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = (event) => {
      const file = event.target.files[0];
      const valid = ValidateUploadedFile({ file, I18n });
      if (!valid.valid) {
        showSnackbar({ message: valid.message, severity: "error" });
        return false;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        handleDataChange(e.target.result, "image_url");
      };
      reader.readAsDataURL(file);
    };
    input.click();
  };

  const handleSetProductName = (item) => {
    triggerLogEvent(analytics, "sb_quick_item_name_suggestion", { product_name: item?.product_name ?? "" });
    setSearchName("");
    setQuickItemStates((prev) => ({
      ...prev,
      ["name"]: item?.product_name ?? "",
      ["selling_price"]: item?.price ?? "",
      ["image_url"]: item?.product_images[0] || "",
    }));
  };

  const handleDataChange = (value, id) => {
    if (id === "name") {
      const valid = validString(value);
      if (!valid) return;
    }
    setQuickItemStates((prev) => ({
      ...prev,
      [id]: value,
    }));
    if (id === "name") {
      setIsLoading(!!value);
      setSearchName(value);
    }
  };

  const handleUnitModalClose = () => {
    setShowUnitModal(false);
    setModalUnitState({
      ["unit"]: "",
      ["secondary_unit"]: "",
      ["unit_conversion"]: "",
    });
  };

  const closePop = (columnId) => {
    setDateSelectRefs((prevRefs) => {
      const newRefs = { ...prevRefs };
      delete newRefs[columnId];
      return newRefs;
    });
  };

  const getRelevantPlaceHolder = (id) => {
    switch (id) {
      case "name":
        return I18n.enter_product_name;
      case "stock":
        return I18n.enter_stock;
      case "low_stock":
        return I18n.enter_low_stock;
      case "unit_conversion":
        return I18n.select_unit_type;
      case "cost_price":
        return I18n.enter_cost_price;
      case "selling_price":
        return I18n.enter_sell_price;
      case "barcode":
        return I18n.enter_barcode;
      case "unit":
        return I18n.unit;
      case "batch_number":
        return I18n.enter_batch_number;
      case "wholesale_price":
        return I18n.enter_wholesale_price;
      case "expiry_date":
        return "dd/mm/yy";
      case "manufacturing_date":
        return "dd/mm/yy";
      case "low_stock":
        return I18n.enter_low_stock;
      default:
        return I18n.enter_value;
    }
  };

  const getAllowedLength = (id) => {
    switch (id) {
      case "stock":
        return 7;
      case "cost_price":
        return 7;
      case "selling_price":
        return 7;
      case "barcode":
        return 50;
      case "batch_number":
        return 50;
      case "wholesale_price":
        return 50;
      case "low_stock":
        return 7;
      default:
        return 100;
    }
  };

  const handleScan = (data) => {
    getProductByBarCode(data);
  };
  const handleError = (err) => {
    if (document.activeElement === nameRef.current && err) {
      showSnackbar({
        message: typeof err === "string" ? err : I18n.barcode_error,
        severity: "error",
        toastId: "barcodeError",
      });
    }
  };
  const handleShowUnitModal = () => {
    setModalUnitState({
      unit: quickItemStates.unit,
      secondary_unit: quickItemStates.secondary_unit,
      unit_conversion: quickItemStates.unit_conversion,
    });
    setShowUnitModal(true);
  };

  useEffect(() => {
    setActiveIndex(-1);
  }, [debounceSearchName]);
  const handleKeyDown = (e) => {
    if (!productList?.length) return;

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setActiveIndex((prev) =>
          prev < productList.length - 1 ? prev + 1 : 0,
        );
        break;

      case "ArrowUp":
        e.preventDefault();
        setActiveIndex((prev) =>
          prev > 0 ? prev - 1 : productList.length - 1,
        );
        break;

      case "Enter":
        if (activeIndex >= 0) {
          e.preventDefault();
          handleSetProductName(productList[activeIndex], "name");
          setSearchName("");
        }
        break;

      case "Tab":
        if (activeIndex >= 0) {
          handleSetProductName(productList[activeIndex], "name");
          setSearchName("");
        }
        break;

      case "Escape":
        setSearchName("");
        break;

      default:
        break;
    }
  };

  const typeValue = quickItemStates["unit"];
  const conversionAvailable = Boolean(
    quickItemStates.unit && quickItemStates.secondary_unit,
  );
  const cost =
    quickItemStates["cost_price"] > 0 ? quickItemStates["cost_price"] : "";
  const sellPrice =
    quickItemStates["selling_price"] > 0
      ? quickItemStates["selling_price"]
      : "";
  const whioleSellPrice =
    quickItemStates["wholesale_price"] > 0
      ? quickItemStates["wholesale_price"]
      : "";

  const difference = Math.abs(Number(sellPrice) - Number(cost));

  useEffect(() => {
    const isLoss = Number(sellPrice) < Number(cost);
    if (isLoss && document.activeElement === costInputRef.current) {
      sellInputRef.current.focus();
      costInputRef.current.focus();
    }
    setIsLoss(isLoss);
  }, [sellPrice, cost]);

  const renderQuickColumn = (columnId) => {
    switch (columnId) {
      case "name":
        return (
          <Box className={styles.imageBoxWrapper}>
            <Box className={styles.nameBox}>
              <Box className={styles.imageBox} id="image_stock_add_quick_item">
                <img
                  tabIndex={0}
                  onClick={handleImageChange}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey) {
                      handleImageChange();
                    }
                  }}
                  src={
                    quickItemStates["image_url"]
                      ? quickItemStates["image_url"]
                      : defaultImage
                  }
                  className={styles.imageInput}
                  role="button"
                  alt=""
                ></img>
              </Box>
              <Box className={styles.nameInputWrapper} position={"relative"}>
                <UBInput
                  variant="standard"
                  size="small"
                  value={quickItemStates["name"]}
                  onChange={(e, value) => handleDataChange(value, "name")}
                  placeholder={I18n.item_name}
                  inputClassname="inputStockField"
                  maxLength={100}
                  onKeyDown={handleKeyDown}
                  autoFocus
                  inputRef={nameRef}
                  inputId="name_add_quick_stock"
                  onBlur={(e) => {
                    if (
                      SearchName &&
                      !((productList ?? []).length > 0) &&
                      !isLoading
                    )
                      return;
                    setTimeout(() => {
                      setSearchName("");
                    }, 200);
                  }}
                />
                {debounceSearchName && (
                  <Box className={styles.itemSuggestionContainer}>
                    <Box className={`${styles.itemSuggestInner} generic-scrollbar`}>
                      <div className={styles.singleItemSuggest}>
                        <ParagraphText className="fontSize12 foundationInk400">
                          {I18n.catalog_items}
                        </ParagraphText>
                      </div>
                      {isLoading ? (
                        <Box
                          height="40px"
                          display="flex"
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          <CircularProgress size={20} />
                        </Box>
                      ) : (productList ?? []).length > 0 ? (
                        (productList ?? []).map((item, index) => (
                          <div
                            key={index}
                            ref={(el) => (itemRefs.current[index] = el)}
                            onClick={() => handleSetProductName(item, "name")}
                            className={`${styles.singleItemSuggest} thover_color_foundation_Blue transition_background_color pointer
      ${activeIndex === index ? "highlighted" : ""}
    `}
                          >
                            <ParagraphText className="fontSize12 newFontColor">
                              {item?.product_name ?? ""}
                            </ParagraphText>
                            <ParagraphText className="fontSize12 newFontColor">
                              Rs. {item?.price ? formatNum(item?.price) : 0}{" "}
                            </ParagraphText>
                          </div>
                        ))
                      ) : (
                        <ParagraphText
                          className={`fontSize12 newFontColor ${styles.notFoundStyle}`}
                        >
                          {I18n.item_not_found}
                          <span
                            tabIndex={0}
                            className={styles.createYourOwnItem}
                            onClick={() => setSearchName("")}
                          >
                            <span className={styles.plusIcon}>
                              <PlusIconUnFill />
                            </span>
                            {I18n.create_your_own_item}
                          </span>
                        </ParagraphText>
                      )}
                    </Box>
                    <div className={styles.borderLine} />
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        );
      case "stock":
      case "low_stock":
        return (
          <Box className={styles.inputs}>
            <UBInput
              inputId={columnId === "stock" ? "stock_add_quick_stock" : "lowstock_add_quick_stock"}
              value={quickItemStates[columnId] || ""}
              onChange={(e, value) => {
                const inputValue = value.replace(/^Rs\./, "");
                if (/^\d*$/.test(inputValue)) {
                  if (inputValue.length <= getAllowedLength(columnId)) {
                    handleDataChange(inputValue, columnId);
                  }
                }
              }}
              placeholder={getRelevantPlaceHolder(columnId)}
            />
          </Box>
        );
      case "unit":
        return (
          <Box
            className={styles.dropdown}
            onClick={handleShowUnitModal}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) handleShowUnitModal();
            }}
            tabIndex={0}
            id="unit_add_quick_stock"
          >
            <div className={`${styles.unitDropdown} cursorPointer`}>
              <Box className={`${styles.dropdownTypoWrapper}`}>
                <Typography
                  className={`${styles.dropdownTypo} truncateOneLine`}
                  color={typeValue ? "var(--newFontColor)" : "var(--newLightColor)"}
                  textAlign={"left"}
                  variant="body2"
                  component="span"
                >
                  {typeValue || I18n.unit}
                </Typography>
                {conversionAvailable && (
                  <p className={`${styles.unitConversionText} truncateOneLine`} id="unit_conv_add_quick_stock">
                    1 {quickItemStates.unit} = {quickItemStates.unit_conversion}{" "}
                    {quickItemStates.secondary_unit}
                  </p>
                )}
              </Box>
              <div className={styles.dropdownIcon}>
                <DropDown width={"20px"} height={"20px"} />
              </div>
            </div>              
          </Box>
        );
      case "cost_price":
      case "selling_price": {
        const isSell = columnId === "selling_price";
        const value = isSell ? sellPrice : cost;
        return (
          <Box className={`${styles.inputs} ${styles.inputsAlignRight} ${isSell && isLoss ? styles.inputsError : ""}`}>
            <Tooltip
              slotProps={{
                tooltip: {
                  sx: {
                    backgroundColor: "var(--error-light)",
                    padding: "0.5rem",
                    color: "var(--red)",
                    fontFamily: "outfit",
                  },
                },
                arrow: {
                  sx: {
                    color: "var(--error-light)",
                    fontSize: "1rem",
                  },
                },
              }}
              title={`Loss Rs. ${difference}`}
              open={isSell && isLoss}
              arrow
            >
              <UBInput
                inputId={isSell ? "sell_add_quick_stock" : "cost_add_quick_stock"}
                inputRef={isSell ? sellInputRef : costInputRef}
                value={value ? `Rs. ${value}` : ""}
                onChange={(e, inputValue) => {
                  if (validatePriceQtyInput(inputValue, 9999999)) {
                    const result = removeLeadingZeros(removeRsFromValue(inputValue));
                    handleDataChange(result, columnId);
                  }
                }}
                placeholder={getRelevantPlaceHolder(columnId)}
              />
            </Tooltip>
          </Box>
        );
      }
      case "barcode":
      case "batch_number":
        return (
          <Box className={styles.inputs}>
            <UBInput
              inputId={
                columnId === "barcode"
                  ? "barcode_add_quick_stock"
                  : "batchNumber_add_quick_stock"
              }
              value={quickItemStates[columnId] || ""}
              onChange={(e, value) => {
                const inputValue = value.replace(/^Rs\./, "");
                if (/^\d*$/.test(inputValue)) {
                  if (inputValue.length <= getAllowedLength(columnId)) {
                    handleDataChange(inputValue, columnId);
                  }
                }
              }}
              placeholder={getRelevantPlaceHolder(columnId)}
            />
          </Box>
        );
      case "wholesale_price":
        return (
          <Box className={`${styles.inputs} ${styles.inputsAlignRight}`}>
            <UBInput
              inputId="wholesell_add_quick_stock"
              value={whioleSellPrice ? `Rs. ${whioleSellPrice}` : ""}
              onChange={(e, value) => {
                if (validatePriceQtyInput(value, 9999999)) {
                  const result = removeLeadingZeros(removeRsFromValue(value));
                  handleDataChange(result, "wholesale_price");
                }
              }}
              placeholder={getRelevantPlaceHolder("wholesale_price")}
            />
          </Box>
        );
      case "expiry_date":
      case "manufacturing_date": {
        const isExpiry = columnId === "expiry_date";
        return (
          <Box className={styles.dateInput}>
            <UBDateSelect
              id={isExpiry ? "expiryDate_add_quick_stock" : "manufactureDate_add_quick_stock"}
              closePop={() => closePop(columnId)}
              dateSelect={dateSelectRefs[columnId]}
              selectedDate={quickItemStates[columnId]}
              placeholderColor={"newLightColor"}
              setSelectedDate={(value) => {
                if (
                  isExpiry &&
                  value &&
                  quickItemStates.manufacturing_date &&
                  value.isBefore(quickItemStates.manufacturing_date)
                ) {
                  showSnackbar({
                    message: I18n.expiry_greater_manufactor_validation_msg,
                    severity: "error",
                    toastId: "secondaryUnitError",
                  });
                  return;
                }
                if (
                  !isExpiry &&
                  value &&
                  quickItemStates.expiry_date &&
                  value.isAfter(quickItemStates.expiry_date)
                ) {
                  showSnackbar({
                    message: I18n.manufactor_lower_expiry_validation_msg,
                    severity: "error",
                    toastId: "secondaryUnitError",
                  });
                  return;
                }
                handleDataChange(value, columnId);
              }}
              title={""}
              labelIcon={null}
              placeholder="dd/mm/yy"
            />
          </Box>
        );
      }
      default:
        return null;
    }
  };

  return (
    <div
      className={`ub_ButtonMain ${styles.addQuickItemWrapper} ${makeQuickItem ? styles.stockItemRowActive : ""}`}
    >
      {makeQuickItem === false ? (
        <UBButton
          id="stock_add_quick_item"
          title={I18n.add_quick_item}
          className={`textUppercase ${styles.addQuickItemButton}`}
          onClick={enableQuickItem}
          iconComponent={<ActionPlusIcon />}
        />
      ) : (
        <Box
          className={`StockItem ${styles.stockItemRow}`}
          sx={{
            width: "100%",
            minWidth: 0,
            display: "grid",
            gridTemplateColumns,
            "& > .MuiBox-root": {
              minWidth: 0,
              boxSizing: "border-box",
            },
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" && e.shiftKey) {
              e.preventDefault();
              if (enableSave) {
                blurAllInputField();
                addQuickItem();
              }
            }
          }}
        >
          {visibleColumns.map((columnId) => (
            <Box key={columnId} alignItems="center" className={styles.boxWrapper}>
              {renderQuickColumn(columnId)}
            </Box>
          ))}
          <Box className={styles.fixedActionsColumn}>
            {enableSave ? (
              <UBButton
                id="save_add_quick_stock"
                title={I18n.quick_item_save}
                className={`${styles.savequickitem} ubPrimaryButton textUppercase`}
                onClick={(e) => {
                  e.stopPropagation();
                  addQuickItem();
                }}
              ></UBButton>
            ) : (
              <UBButton
                id="cancel_add_quick_stock"
                title={I18n.quick_item_cancel}
                className={`${styles.cancelquickitem} ubSecondaryButton textUppercase`}
                onClick={(e) => {
                  e.stopPropagation();
                  cancelQuickItem();
                }}
              ></UBButton>
            )}
          </Box>
        </Box>
      )}

      <UnitModal
        open={showUnitModal}
        business={business}
        handleClose={() => setShowUnitModal(false)}
        unitState={modalUnitState}
        onSave={(item) => {
          setModalUnitState({
            ...item,
          });
          setQuickItemStates((prev) => ({
            ...prev,
            ...item,
          }));
          setShowUnitModal(false);
        }}
      />
      <BarcodeReader onError={handleError} onScan={handleScan} />
    </div>
  );
};

const enhance = withObservables(["business"], ({ business }) => ({
  customUnit: business.unit.observe(),
}));

export default enhance(AddQuickItem);
